import * as React from "react";

const HerbIcon: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20.566" height="22.01" viewBox="0 0 20.566 22.01">
            <g id="Group_8" data-name="Group 8" transform="translate(-1101.276 -9.307)">
                <path
                    id="Path_7"
                    data-name="Path 7"
                    d="M712,23.2s-4.538-5.56-.367-7.917a25.189,25.189,0,0,0,6.9-5.975,31.6,31.6,0,0,0,0,5.975c.228,4.055-3.224,5.891-4.559,6.59A8.974,8.974,0,0,0,712,23.2Z"
                    transform="translate(397)"
                    fill="#205c40"
                />
                <path
                    id="Path_8"
                    data-name="Path 8"
                    d="M708.854,27.692c1.7-3.629.963-5.463-4.421-7C703.837,25.31,704.865,27.381,708.854,27.692Z"
                    transform="translate(397 -0.113)"
                    fill="#205c40"
                />
                <path
                    id="Path_9"
                    data-name="Path 9"
                    d="M713.374,26.924c.889-1.917,2.661-7.308,11.468-4.856C722.925,23.811,719.02,33.338,713.374,26.924Z"
                    transform="translate(397 -0.15)"
                    fill="#205c40"
                />
                <path
                    id="Path_10"
                    data-name="Path 10"
                    d="M710.232,31.456s-.112-5.857,2.03-9.987"
                    transform="translate(397 -0.15)"
                    fill="none"
                    stroke="#205c40"
                    stroke-width="1"
                />
                <path
                    id="Path_11"
                    data-name="Path 11"
                    d="M716.1,25.233s-5.548,3.65-5.8,5.519"
                    transform="translate(397 -0.532)"
                    fill="none"
                    stroke="#205c40"
                    stroke-width="1"
                />
                <path
                    id="Path_12"
                    data-name="Path 12"
                    d="M710.305,26.845s1.964,2.039,2.062,3.907"
                    transform="translate(394.938 -0.532)"
                    fill="none"
                    stroke="#205c40"
                    stroke-width="1"
                />
            </g>
        </svg>
    );
};

export default React.memo(HerbIcon);
